import React from 'react';
import { Container, Grid, Typography, Card, CardContent } from '@mui/material';
import { motion } from 'framer-motion';
import CodeIcon from '@mui/icons-material/Code';
import WebIcon from '@mui/icons-material/Web';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import BusinessIcon from '@mui/icons-material/Business';
import CloudQueueIcon from '@mui/icons-material/CloudQueue';
import ApiIcon from '@mui/icons-material/Api';
import './ServicesOverview.css';

const services = [
  {
    icon: <CodeIcon sx={{ fontSize: 40 }} />,
    title: 'Custom Software Development',
    description: 'Tailored software solutions designed to address your unique business challenges and requirements.'
  },
  {
    icon: <WebIcon sx={{ fontSize: 40 }} />,
    title: 'Web Applications',
    description: 'Responsive and scalable web applications built with modern technologies and best practices.'
  },
  {
    icon: <PhoneIphoneIcon sx={{ fontSize: 40 }} />,
    title: 'Mobile Apps',
    description: 'Native and cross-platform mobile applications that deliver exceptional user experiences.'
  },
  {
    icon: <BusinessIcon sx={{ fontSize: 40 }} />,
    title: 'Enterprise Solutions',
    description: 'Comprehensive enterprise-grade solutions that streamline operations and boost productivity.'
  },
  {
    icon: <CloudQueueIcon sx={{ fontSize: 40 }} />,
    title: 'Cloud Solutions',
    description: 'Cloud-native applications and migration services for improved scalability and performance.'
  },
  {
    icon: <ApiIcon sx={{ fontSize: 40 }} />,
    title: 'API Integration',
    description: 'Seamless integration services connecting your systems with third-party applications and services.'
  }
];

const ServicesOverview = () => {
  return (
    <section className="services-overview">
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Typography variant="h2" className="sd-section-title" gutterBottom>
            Our Software Development Services
          </Typography>
          <Typography variant="subtitle1" className="sd-section-subtitle" gutterBottom>
            Comprehensive solutions tailored to your needs
          </Typography>
        </motion.div>

        <Grid container spacing={4} className="services-grid">
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <Card className="sd-service-card">
                  <CardContent>
                    <div className="sd-service-icon">
                      {service.icon}
                    </div>
                    <Typography variant="h6" className="sd-service-title">
                      {service.title}
                    </Typography>
                    <Typography variant="body2" className="sd-service-description">
                      {service.description}
                    </Typography>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </section>
  );
};

export default ServicesOverview; 